"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
const core_1 = require("@material-ui/core");
const Paper_1 = require("@material-ui/core/Paper");
const Clear_1 = require("@material-ui/icons/Clear");
const Search_1 = require("@material-ui/icons/Search");
const material_table_1 = require("material-table");
const React = require("react");
const icons_1 = require("@brikl-ui/icons");
const Toolbar = core_1.withStyles({
    root: {
        padding: 0,
        minHeight: 0,
        paddingBottom: 10
    }
})(material_table_1.MTableToolbar);
const TableColors = {
    header: {
        backgroundColor: '#555555',
        color: 'white'
    }
};
function Table(props) {
    const { backgroundTransparent } = props, rest = __rest(props, ["backgroundTransparent"]);
    return (React.createElement(material_table_1.default, Object.assign({ icons: {
            Search: React.forwardRef((props, ref) => (React.createElement(Search_1.default, Object.assign({}, props, { ref: ref })))),
            ResetSearch: React.forwardRef((props, ref) => (React.createElement(Clear_1.default, Object.assign({}, props, { ref: ref })))),
            SortArrow: React.forwardRef((props, ref) => (React.createElement(icons_1.ArrowDown, Object.assign({}, props, { ref: ref }))))
        }, components: {
            Container: (_a) => {
                var { style } = _a, containerProps = __rest(_a, ["style"]);
                if (props.backgroundTransparent) {
                    style.background = 'transparent';
                }
                return (React.createElement(Paper_1.default, Object.assign({}, containerProps, { elevation: props.elevation, style: style })));
            },
            Toolbar: props => {
                return React.createElement(Toolbar, Object.assign({}, props));
            }
        }, options: {
            searchFieldAlignment: 'left',
            searchFieldStyle: {
                background: 'white',
                padding: '5px 12px',
                borderRadius: '5px',
                marginLeft: '0px'
            },
            search: props.searchable,
            draggable: false,
            paging: false,
            showTitle: false,
            toolbar: props.searchable,
            headerStyle: TableColors.header
        } }, rest)));
}
exports.Table = Table;
Table.defaultProps = {
    searchable: false,
    elevation: 0,
    backgroundTransparent: true
};
//# sourceMappingURL=Table.js.map